export const defaultPaginationState = {
    start: 0,
    limit: 4,
    step: 4,
    page: 1,
    isNextPageAvailable: true,
};